import { render, staticRenderFns } from "./TypeContent.vue?vue&type=template&id=66233883&scoped=true"
import script from "./TypeContent.vue?vue&type=script&lang=js"
export * from "./TypeContent.vue?vue&type=script&lang=js"
import style0 from "./TypeContent.vue?vue&type=style&index=0&id=66233883&prod&lang=scss&scoped=true"
import style1 from "./TypeContent.vue?vue&type=style&index=1&id=66233883&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66233883",
  null
  
)

export default component.exports